













































































import { Vue, Component } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { BadgesQuery, BadgesQuerySymbol, LoadingPhase, RemoteStateQueryPhase, BadgeStatus } from '../store';
import { QueriedBadge } from '../store/badge-query';
import { setFocus } from '@/app/accessibility/accessibility-utils';
import LoadingComponent from '@/app/shared/components/loading-component.vue';
import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
import WrapperSimpleComponent from '@/app/shared/components/wrapper/wrapper-simple-component.vue';
import WrapperModalComponent from '@/app/shared/components/wrapper/wrapper-modal-component.vue';
import UiPagerComponent from '@/app/shared/components/ui/ui-pager-component.vue';
import UiDropDownComponent from '@/app/shared/components/ui/ui-drop-down-component.vue';
import UiScrollableComponent from '@/app/shared/components/ui/ui-scrollable-component.vue';
import UiBadgeComponent from '@/app/shared/components/ui/ui-badge-component.vue';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";

const DEFAULT_PER_PAGE: number = 6;

@Component({
  components: {
    LoadingComponent,
    WrapperCommonComponent,
    WrapperSimpleComponent,
    WrapperModalComponent,
    UiPagerComponent,
    UiDropDownComponent,
    UiScrollableComponent,
    UiBadgeComponent,
    HelpPopupComponent
  }
})
export default class BadgesDashboardComponent extends Vue {
  public currentPage: number = 1;
  public selectedBadge: QueriedBadge|null = null;

  @lazyInject(BadgesQuerySymbol)
  private badgesQuery: BadgesQuery;

  get items() {
    return this.badgesQuery.badges;
  }

  get shouldShowBadges(): boolean {
    return this.loadingPhase === 'loading' || (
      this.loadingPhase === 'loaded' && this.items.length > 0
    )
  }

  get loadingPhase(): LoadingPhase {
    return this.badgesQuery.loadingPhase;
  }

  get remotePhase(): RemoteStateQueryPhase {
    return this.badgesQuery.remotePhase;
  }

  get pageCount(): number {
    return Math.ceil(this.items.length / this.perPage);
  }

  get pagedItems() {
    const start: number = (this.currentPage - 1) * this.perPage;
    const end: number = start + this.perPage;
    return this.items.slice(start, end);
  }

  private get perPage(): number {
    return DEFAULT_PER_PAGE;
  }

  public getLinkId(badgeId: string): string {
    return `badge-link-${badgeId}`;
  }

  public getTitleId(badgeId: string): string {
    return `badge-title-${badgeId}`;
  }

  public getSchema(status: BadgeStatus): 'inactive'|null {
    return status === 'not-earned' ? 'inactive' : null;
  }

  public onClick(item: QueriedBadge): void {
    this.selectedBadge = item;
  }

  public deselectBadge(): void {
    if (this.selectedBadge !== null) {
      const id: string = this.getLinkId(this.selectedBadge.id);
      setFocus(`#${id}`);
    }

    this.selectedBadge = null;
  }

  private badgeMotivationText() {
    let earnedCount = this.items.filter(x => x.status === 'earned').length
    if (this.items.length === 0) {
      return ''
    }

    if (this.items.length === earnedCount) {
      return this.$t('dashboard.badge_all_earned')
    }

    return this.$t('dashboard.badge_motivation')
  }

  private isEarnedBadge(badge: QueriedBadge): boolean {
    return badge.status === 'earned';
  }

  public subtitleInModal(badge: QueriedBadge): string {
    if (this.isEarnedBadge(badge) && this.$options.filters) {
      return this.$options.filters.datetime(badge.date);
    }

    return '';
  }
}
